// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyPics-module--container--1jacu"};